import { render } from "./AddEncaissementPage.vue?vue&type=template&id=65af10a3&ts=true"
import script from "./AddEncaissementPage.vue?vue&type=script&lang=ts"
export * from "./AddEncaissementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__